import { render, staticRenderFns } from "./categoryTab.vue?vue&type=template&id=2b45a378&scoped=true&"
import script from "./categoryTab.vue?vue&type=script&lang=js&"
export * from "./categoryTab.vue?vue&type=script&lang=js&"
import style0 from "./categoryTab.vue?vue&type=style&index=0&id=2b45a378&lang=css&scoped=true&"
import style1 from "./categoryTab.vue?vue&type=style&index=1&lang=css&"
import style2 from "./categoryTab.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45a378",
  null
  
)

export default component.exports